import { Component, signal, inject } from '@angular/core';
import { LibPageHeaderComponent, LibTermsAndConditionComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { IPageHeaderEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { ActivatedRoute, Router } from '@angular/router';
import { IMeta, MetaService } from '@web-nx-ng-tsc/util-meta';

@Component({
  selector: 'app-cookies-policy',
  standalone: true,
  imports: [LibPageHeaderComponent, LibTermsAndConditionComponent],
  templateUrl: './cookies-policy.component.html',
  styleUrl: './cookies-policy.component.scss',
})
export class CookiesPolicyComponent {
  // Inject
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly metaService = inject(MetaService);

  pageHeaderObj = signal<IPageHeaderEntity>({
    pageTitle: 'นโยบายการใช้คุกกี้',
    pageSubTitle: '(Cookies Policy)',
    subTitles: [
      {
        title: 'หน้าแรก',
        partName: '/',
      },
      {
        title: 'นโยบายการใช้คุกกี้ (Cookies Policy)',
        partName: '/cookies-policy',
      },
    ],
  });

  cookiesPolicyObj = [
    {
      title: 'คุกกี้คืออะไร',
      subtitle: [
        {
          headers:
            'คุกกี้เป็นไฟล์ข้อมูลขนาดเล็กที่ถูกเก็บไว้ในอุปกรณ์ของคุณเมื่อคุณเข้าใช้งานเว็บไซต์ เพื่อช่วยให้การใช้งานเว็บไซต์มีประสิทธิภาพมากขึ้นและช่วยให้บริษัทเก็บรวบรวมข้อมูลการใช้งานของผู้ใช้',
        },
      ],
    },
    {
      title: 'ประเภทของคุกกี้ที่เราใช้',
      subtitle: [
        {
          headers: 'คุกกี้ที่จำเป็น (Necessary Cookies): เพื่อให้เว็บไซต์ทำงานได้อย่างถูกต้องและรองรับฟังก์ชันพื้นฐาน',
        },
        {
          headers:
            'คุกกี้เพื่อวิเคราะห์ (Analytical Cookies): เพื่อเก็บข้อมูลเกี่ยวกับการใช้งานเว็บไซต์ เช่น จำนวนผู้เข้าชม และพฤติกรรมการใช้งาน',
        },
        {
          headers: 'คุกกี้เพื่อการโฆษณา (Advertising Cookies): เพื่อแสดงเนื้อหาหรือโฆษณาที่ตรงตามความสนใจของผู้ใช้งาน',
        },
        {
          headers:
            'คุกกี้ฟังก์ชัน (Functional Cookies): เพื่อปรับแต่งการใช้งานเว็บไซต์ให้เหมาะสมกับความต้องการของผู้ใช้งาน',
        },
      ],
    },
    {
      title: 'การจัดการคุกกี้',
      subtitle: [
        {
          headers:
            'ผู้ใช้งานสามารถตั้งค่าการใช้งานคุกกี้ได้ผ่านเบราว์เซอร์ หากปิดการใช้งานคุกกี้บางประเภท อาจส่งผลต่อการทำงานของเว็บไซต์บางส่วน',
        },
        {
          headers: 'ผู้ใช้งานสามารถลบหรือปิดการใช้งานคุกกี้ได้ทุกเมื่อผ่านการตั้งค่าในอุปกรณ์ของตน',
        },
      ],
    },
    {
      title: 'การเปลี่ยนแปลงนโยบายคุกกี้',
      subtitle: [
        {
          headers:
            'บริษัทขอสงวนสิทธิ์ในการปรับเปลี่ยนนโยบายนี้ได้ตลอดเวลา โดยการเปลี่ยนแปลงจะมีผลทันทีหลังจากประกาศบนเว็บไซต์',
        },
      ],
    },
    {
      title: 'การติดต่อ',
      subtitle: [
        {
          headers: 'หากคุณมีคำถามเพิ่มเติมเกี่ยวกับการใช้คุกกี้ กรุณาติดต่อเราที่ 02-024 8091-9',
        },
      ],
    },
  ];

  constructor() {
    this.metaService.updateMeta(this.route.snapshot.data as IMeta);
    this.onSetOpenGraphTags();
  }

  redirectTo(url: string) {
    this.router.navigate([`${url}`]);
  }

  onSetOpenGraphTags() {
    this.metaService.updateOpenGraph({
      title: 'นโยบายคุกกี้ | ADVANCE TYRE Thailand',
      description:
        'ชี้แจงประเภทคุกกี้ วัตถุประสงค์ด้านฟังก์ชัน การวิเคราะห์ และการโฆษณา อธิบายผลต่อประสบการณ์ผู้ใช้ พร้อมวิธีตั้งค่า/จัดการความยินยอมในเบราว์เซอร์ คุณสามารถปรับเปลี่ยนการยินยอมได้ทุกเมื่อ เพื่อให้การใช้งานเว็บไซต์เหมาะกับความต้องการมากที่สุด | ADVANCE TYRE Thailand',
      image: 'https://tsc-pub-blob.s3.ap-southeast-7.amazonaws.com/2025-08/logo.webp',
    });
  }
}
